// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"158":"social","575":"options","597":"projects","679":"basic","710":"addons"}[chunkId] || chunkId) + "." + {"158":"a9832e3a","202":"79d43285","459":"796cd14f","575":"7d010ba9","597":"3e36ce9d","679":"44b08cfb","710":"a62e5b96","840":"67c6c63a","850":"136b75cf","899":"be4ae544"}[chunkId] + ".js";
};